"use strict";
var ACC;
ACC.register = {

	_autoload: [
	    "clearForm",
		"pageLoginAlerts",
		"regValidateForm",
		"registerFormCheck",
		"forgotEmailCheck",
		"checkoutPasswordCheck"
	],
	clearForm: function(){
		if($('#tjxRegisterForm')[0] != null){
			$('#tjxRegisterForm')[0].reset();
		}
	},

	pageLoginAlerts: function() {
		var $body = $('body');
		/**
		 * Login page error header correction for login and checkout-login pages.
		 * This function is used solely to reposition the global login and session error messages.
		 * It should be removed once we refactor the way we handle global errors.
		 */
		if (
			$body.hasClass('page-checkout-login') ||
			$body.hasClass('page-login') ||
			$body.hasClass('page-updateAccountDetailsPage')
		) {
			var $errorContainer = $('.global-message-container');

			if ($errorContainer.length) {
				// remove the error container from the DOM, keeping any jQuery-associated data
				var $errorNode = $errorContainer.detach();
				/**
				 * Prepend the error message to the correctly-positioned error container div
				 * and then display it. The .show() is necessary to override the styles that
				 * initially hide the error message when the page loads.
				 */
				$errorNode.prependTo('.login-error-container').show();
			}
		}
	},

	forgotEmailCheck: function (){
		var $forgottenPwdForm = $("#tjxForgottenPwdForm .form-group");

		if ($forgottenPwdForm.hasClass('has-error') === true ) {
			$forgottenPwdForm.find('input:not([type="radio"])').siblings('label').before ('<i class="icon icon-cancel-circled error"></i>');
			$forgottenPwdForm.find('.form-select label').before ('<i class="icon icon-cancel-circled error"></i>');
			$forgottenPwdForm.find("input").addClass('form-error');
		}
	},

	regValidateForm: function (){
		//Login Validation
		var openRegForm;
		var focus = true;
		if(window.location.href.indexOf("register") > -1) {
				openRegForm = true;
		}

		$('#tjxRegisterForm .form-group').each(function () {
			var $thisGroup = $(this);
			if ($thisGroup.hasClass('has-error') === true ) {
				var inputObj = $(this).find('input.form-control');
				$thisGroup.prepend ('<i class="icon icon-cancel-circled error"></i>');
				$thisGroup.find("input").addClass('form-error');
				$thisGroup.find("select").addClass('form-error');

				if ($("[name='emailExists']").val() === 'true'){
					$('.alert-dismissable').find('.errorMsg').html($thisGroup.find('.help-block span').html());
					$thisGroup.find('.help-block span').html('');
				}

				if ($(inputObj).attr('name') == 'checkPwd') {
					var pwd = $(this).prev();
					var clsName = $(pwd).attr('class');
					if (clsName.indexOf('has-error') < 0){
						var pwdInputObj = $(pwd).find('input.form-control');
						var errorMsg = $(pwdInputObj).data('error');
						$(pwd).addClass('has-error');
						$(pwd).prepend ('<i class="icon icon-cancel-circled error"></i>');
						var divStr = "<div class=\"help-block\"><span>" +  errorMsg + "</span></div>";
						$(pwd).append(divStr);
					 }
				}
			}
			else {
				if ($thisGroup.find('input[type="text"]').val() != undefined && $.trim($thisGroup.find('input[type="text"]').val()) !== '') {
					$thisGroup.prepend ('<i class="tick icon icon-check-circle"></i>');
					$thisGroup.find("input").addClass('form-success');
				}
				if ($thisGroup.find('select').val() != undefined || $thisGroup.find('select').val() != null){
					$thisGroup.prepend ('<i class="tick icon icon-check-circle"></i>');
					$thisGroup.find("select").addClass('form-success');
				}
		   }
		});

		var $loginContainer = $('.login-page-container');
		if (openRegForm === true) {
			$('#login-sign-in').attr('class','tab-pane fade');
			$('#login-register').attr('class','tab-pane fade active in');
			$loginContainer.find ('.siginin-tab').removeClass('active');
			$loginContainer.find ('.register-tab').addClass('active');
		}
		$loginContainer.css('display', 'block');

		$('#tjxRegisterForm .form-group').each(function () {
			var $thisGroup = $(this);
			if ($thisGroup.hasClass('has-error') === true ) {
				var inputType = $thisGroup.find("input, select").data('type');
				if (inputType === 'validate' && focus === true) {
					$thisGroup.find('input, select').focus();
					focus = false;
				}
			}
		});
	},

    registerFormCheck: function(){
        $('#registerTitle').selectric();

		$('#tjxRegisterForm input[type="text"]').blur(function(){
			 var $thisInput = $(this),
			 	txtValue = $.trim($thisInput.val()),
			 	$parentClass = $thisInput.closest(".form-group"),
			 	inputType = $thisInput.data('type'),
			 	errorMsg = $thisInput.data('error'),
			 	errorMsgRegex = $thisInput.data('error-regex'),
			 	validationRegex = $thisInput.data('validation-regex'),
			 	divStr = "<div class=\"help-block\"><span>" +  errorMsg + "</span></div>",
			 	divStrRegex = "<div class=\"help-block\"><span>" +  errorMsgRegex + "</span></div>";

			 if (inputType === 'validate'){
				 if (txtValue !== ''){
					//  not empty
					 if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
					 $parentClass.prepend('<i class="tick icon icon-check-circle"></i>');
					 $parentClass.removeClass('has-error');
					 if ($parentClass.find('div.help-block').length === 1) {
						 $parentClass.find('div.help-block span').html('');
					 }
					 var regexTest = new RegExp(validationRegex);
					 var valid = regexTest.test(txtValue);
					 if (valid === false) {
						 if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
						 $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
						 $parentClass.addClass('has-error');
						 if ($parentClass.find('div.help-block').length === 1) {
							 $parentClass.find('div.help-block span').html(errorMsgRegex);
						 }  else {
							 $parentClass.append(divStrRegex);
						 }
					 }
				 } else {
					//  empty
					 if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
					 $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
					 $parentClass.addClass('has-error');
					 if ($parentClass.find('div.help-block').length === 1) {
						 $parentClass.find('div.help-block span').html(errorMsg);
					 }  else {
						 $parentClass.append(divStr);
					 }
				 }
			 }
		});

		$('#registerEmail, #j_username').blur(function(){
			 var $obj = $(this);
			 var $parentClass = $obj.closest(".form-group");
			 var emailId = $.trim($obj.val());
			 var errorMsg;
			 if (emailId === ''){
				 errorMsg = $obj.data('error');
			 } else {
				 errorMsg = $obj.data('validemail');
			 }

			 var email = $(this).val(),
			  divStr = "<div class=\"help-block\"><span>" +  errorMsg + "</span></div>",
			 	emailProperty = $(this).data('validation-regex'),
			 	regex = new RegExp(emailProperty),
				$divRole = $parentClass.find('[role="alert"]');

			 if (regex.test(email)) {
				 if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
		    	 if ($parentClass.find('div.help-block').length === 1) {
		    		 $parentClass.find('div.help-block span').html('');
		    	 }
				 $parentClass.removeClass('has-error');
				 if (window.location.href.includes('/login/checkout')){
					ACC.checkout.handleExperianEmailValidation();
				 } 
			 } else {
				 if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
		    	 if ($parentClass.find('div.help-block').length === 1) {
		    		 $parentClass.find('div.help-block span').html(errorMsg);
		    	 } else {
					ACC.checkout.clearAPISuggestions();
		    		 $divRole.append(divStr);
		    	 }
					 $parentClass.find('#j_username').attr('aria-invalid', 'true')
		    	 $parentClass.addClass('has-error');
		    	 $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
			 }
		 });

		$('#tjxGuestRegisterForm input').focus(function(){
			// reset label message
			var $parentClass = $(this).parent();
			$parentClass.removeClass('has-error');
			$parentClass.find('i').remove();
			$parentClass.find('div.help-block span').html('');
 		});

		$('#tjxGuestRegisterForm #guest-checkPwd').keyup(function() {
			ACC.validation.checkPassword($(this));
		});
		$('#tjxGuestRegisterForm #guest-checkPwd').blur(function() {
			ACC.validation.checkPassword($(this));
		});

		$('#tjxRegisterForm #registerPassword, #tjxGuestRegisterForm #registerPassword').blur(function(){
			ACC.validation.passwordInput($(this));
		});

		 $('#checkPwd').blur(function(){
				 var $parentClass = $(this).closest(".form-group"),
				 	confirmPasswordValue = $.trim($(this).val()),
				 	passwordValue = $.trim($('#registerPassword').val()),
				 	errorMsg;

				 if (confirmPasswordValue === ''){
					 errorMsg = $(this).data('nullerror');
				 } else {
					 errorMsg = $(this).data('error');
				 }
				 //var noData = $(this).data('nullerror');
				 var divStr = "<div class=\"help-block\"><span>" +  errorMsg + "</span></div>";
				 if ((passwordValue !== confirmPasswordValue) && (passwordValue !== '')) {
					 if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
					 $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
					 if ($parentClass.find('div.help-block').length === 1) {
			    		 $parentClass.find('div.help-block span').html(errorMsg);
			    		 $parentClass.addClass('has-error');
			    	 }
					 else {
						 $parentClass.append(divStr);
						 $parentClass.addClass('has-error');
					 }
				 } else {
					 if (passwordValue.length > 0) {
						 if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
						 $parentClass.removeClass('has-error');
						 $parentClass.find('div.help-block span').html('');
						 $parentClass.prepend('<i class="tick icon icon-check-circle"></i>');
					 }

					 if (confirmPasswordValue === '') {
						 if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
						 $parentClass.prepend('<i class="icon icon-cancel-circled error"></i>');
						 if ($parentClass.find('div.help-block').length === 1) {
				    		 $parentClass.find('div.help-block span').html(errorMsg);
				    		 $parentClass.addClass('has-error');
				    	 }
						 else {
							 $parentClass.append(divStr);
							 $parentClass.addClass('has-error');
						 }
					 }
				 }
		});

		$('.login-page-container .nav-tabs li').click(function () {
			if ($(this).hasClass('active') === false ) {
                var tabId = $(this).find('a').attr('href');
                var baseUrl = (window.location.protocol + "//" + window.location.host + window.location.pathname).replace('/guest', '');
                var guestUrl = baseUrl + '/guest' + window.location.search;
                var loggedInUrl = baseUrl + window.location.search;

				$('.global-alerts').remove();
				$('.login-error-container').hide();

                if(tabId === '#loginAsGuest') {
                    history.replaceState({path:guestUrl},'',guestUrl);
                } else {
                    history.replaceState({path: loggedInUrl}, '', loggedInUrl);
                }

            }
		});

		 $("#registerTitle").focus(function () {
		 	}).blur(function () {
		 		var $thisInput = $(this),
					$parentClass = $thisInput.closest(".form-group");
		 		if ($thisInput.val() === null) {
		 			if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
					var divStr = "<div class=\"help-block\"><span>" +  $("#selectMessage").val() + "</span></div>";
		    		$thisInput.closest(".form-group").prepend('<i class="icon icon-cancel-circled error"></i>');
		    		 if ($parentClass.find('div.help-block').length === 1) {
			    		 $parentClass.find('div.help-block span').html($("#selectMessage").val());
			    		 $parentClass.addClass('has-error');
			    	 } else {
			    		 $parentClass.append(divStr);
						 $parentClass.addClass('has-error');
			    	 }
		 		}
		 });

		 $('#registerTitle').change (function (){
			var $thisInput = $(this),
			 	$parentClass = $(this).closest(".form-group");
			 if ($thisInput.val !== "") {
				if ($parentClass.find('i').length > 0){$parentClass.find('i').remove();}
				if ($parentClass.find('div.help-block').length === 1) {
		    		 $parentClass.find('div.help-block span').html('');
		    		 $parentClass.removeClass('has-error');
		    		 $thisInput.closest(".form-group").prepend('<i class="tick icon icon-check-circle"></i>');
		    	 }  else {
		    		 $thisInput.closest(".form-group").prepend('<i class="tick icon icon-check-circle"></i>');
		    	 }
			 }
		 });

		 //Login Bubble Messaging Ticks

		 $("#registerPassword").focus(function() {
			 if($(".pw-form-messaging").is(":visible") !== true) {
				 $(this).closest(".form-group").append('<div class="pw-form-messaging"><div class="pw-form-message-arrow"></div><p class="pw-form-text">'+ACC.pwdHelpCheckText+'</p><p class="status-message-8"><span class="icon icon-check"></span>'+ACC.pwdHelpStatusText+'</p><p class="status-message-char"><span class="icon icon-check"></span>'+ACC.pwdHelpCharsText+'</p></div>');
				 $(this).parent().next().addClass('mobile-pw-checker');
			 }
		});

		$("#registerPassword").keyup(function () {
			 var passValue = $(this).val();
			 if($.trim(passValue).length > 7) {
				 $(".status-message-8").addClass('tick-icon');
			 }else{
				 $('.status-message-8').removeClass('tick-icon');
				 $('.status-message-char').removeClass('tick-icon');
			 }
			 var pwdProperty = $('#passwordRegex').text().trim();
			 var passwordRegex = new RegExp(pwdProperty);
			 if(passwordRegex.test(passValue)){
				 $(".status-message-char").addClass('tick-icon');
			 }else{
				 $('.status-message-char').removeClass('tick-icon');
			 }
			 var characterTick = $('p.status-message-8').hasClass("tick-icon");
			 var letterNumber = $('p.status-message-char').hasClass("tick-icon");
			 if ((characterTick === true) && (letterNumber === true)) {
			 	var $parentClass = $(this).closest(".form-group");
			 	if ($parentClass.find('i').length > 0){
					$parentClass.find('i').remove();
				}
				$(this).closest(".form-group").prepend('<i class="tick icon icon-check-circle"></i>');
				$parentClass.removeClass('has-error');
				$parentClass.find('div.help-block span').html('');
			 }
		});

		$("#registerPassword").focusout(function () {
			$(this).parent().addClass('mobile-pw-checker-error');
		});

	},

	checkoutPasswordCheck: function (){
		$('#checkout-order-guest-form .form-group').each(function () {
			var $thisPwd = $(this);
			if ($thisPwd.hasClass('has-error') === true ) {
				$thisPwd.prepend ('<i class="icon icon-cancel-circled error"></i>');
				$thisPwd.find("input").addClass('form-error');
			}
		});
	}

};


